import {Dispatch, SetStateAction} from 'react';
import {OnStringSetState} from '@pluto/@types';
import {OnSelectCallbackParam} from 'react-daterange-picker';

export interface DateRange {
    start?: moment.Moment;
    end?: moment.Moment;
}

export type DateRangeState = DateRange | undefined;

export enum DateRangePreselects {
    CUSTOM = '',
    Today = 'TODAY',
    Tomorrow = 'TOMORROW',
    NextTwoWeeks = 'NEXT_TWO_WEEKS',
    LastTwoWeeks = 'LAST_TWO_WEEKS',
}

export type OnDatesSelect = (dates: OnSelectCallbackParam) => void;
export type ChangeRange = SetStateAction<DateRangePreselects>;
export type OnPresetSelectType = Dispatch<ChangeRange>;

export interface HandlePickerEffect {
    startDate: string;
    endDate: string;
    setPreselect: OnPresetSelectType;
}

export interface DateRangePickerContainerProps {
    onDatesSelect: OnDatesSelect;
    placeholder?: string;
    dates: DateRangeState;
}

export interface BlurComponentProps {
    dates: DateRangeState;
    onDatesSelect: OnDatesSelect;
    setPreselect: OnPresetSelectType;
}

export interface HandlePickerSelectProps {
    onDatesSelect: OnDatesSelect;
    setStartDate: OnStringSetState;
    setEndDate: OnStringSetState;
    setPreselect: OnPresetSelectType;
}

export interface HandlePickerClearProps {
    onDatesSelect: (val: undefined) => void;
    setStartDate: OnStringSetState;
    setEndDate: OnStringSetState;
    setPreselect: OnPresetSelectType;
}

